import { combineReducers } from 'redux';

import { IImage } from '../../../../../api/images';
import { Actions, ActionTypes } from '../../../../../entities/images/actions';

interface IPhotosDeletingState {
	[id: string]: {
		images: IImage[],
		deleting: boolean
	};
}

interface IPhotosUploadingState {
	[key: string]: {
		uploading: boolean;
		processing: boolean;
		percent: number;
	};
}

export const deleting = (state = {} as IPhotosDeletingState, action: Actions = {} as any): IPhotosDeletingState => {
	switch (action.type) {
		case ActionTypes.IMAGES_DELETE_FROM_PROPERTY_REQUEST:
			return {
				...state,
				[action.payload.id]: {
					...state[action.payload.id],
					images: action.payload.images,
					deleting: true
				}
			};
		case ActionTypes.IMAGES_DELETE_FROM_PROPERTY_RECEIVE:
		case ActionTypes.IMAGES_DELETE_FROM_PROPERTY_FAILURE:
			return {
				...state,
				[action.payload.id]: {
					...state[action.payload.id],
					images: action.payload.images,
					deleting: false
				}
			};
		default:
			return state;
	}
};

export const uploading = (state = {} as IPhotosUploadingState, action: Actions = {} as any): IPhotosUploadingState => {
	switch (action.type) {
		case ActionTypes.IMAGES_UPLOAD_REQUEST:
			return {
				...state,
				[action.payload.id]: {
					uploading: true,
					processing: false,
					percent: 0
				}
			};
		case ActionTypes.IMAGES_UPLOAD_PERCENT:
			return {
				...state,
				[action.payload.id]: {
					...state[action.payload.id],
					// percentage is ADDITIVE now that we are sending updates per file
					percent: state[action.payload.id].percent + action.payload.percent
				}
			};
		case ActionTypes.IMAGES_UPLOAD_SENT:
			return {
				...state,
				[action.payload.id]: {
					...state[action.payload.id],
					uploading: false,
					processing: true
				}
			};
		case ActionTypes.IMAGES_UPLOAD_RECEIVE:
		case ActionTypes.IMAGES_UPLOAD_FAILURE:
			return {
				...state,
				[action.payload.id]: {
					...state[action.payload.id],
					uploading: false,
					processing: false
				}
			};
		default:
			return state;
	}
};

export const errors = (state: { [id: string]: string } = {}, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.IMAGES_UPLOAD_FAILURE:
			let error = action.payload.error.error;
			const status = action.payload.error.status;
			if (status === 413) error = 'PAYLOAD_TOO_LARGE';
			return { ...state, [action.payload.id]: error };
		case ActionTypes.IMAGES_UPLOAD_REQUEST:
		case ActionTypes.IMAGES_UPLOAD_RECEIVE:
		case ActionTypes.IMAGES_DELETE_FROM_PROPERTY_REQUEST:
			return {};
		default:
			return state;
	}
};

export const successes = (state: { [id: string]: IImage[] } = {}, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.IMAGES_UPLOAD_RECEIVE:
			return { ...state, [action.payload.id]: action.payload.uploaded };
		case ActionTypes.IMAGES_UPLOAD_REQUEST:
		case ActionTypes.IMAGES_UPLOAD_FAILURE:
		case ActionTypes.IMAGES_DELETE_FROM_PROPERTY_REQUEST:
			return {};
		default:
			return state;
	}
};

export const loading = (state = false, action: Actions = {} as any) => {
	switch (action.type) {
		case ActionTypes.IMAGES_GET_BY_PROPERTY_ID_REQUEST:
			return true;
		case ActionTypes.IMAGES_GET_BY_PROPERTY_ID_RECEIVE:
		case ActionTypes.IMAGES_GET_BY_PROPERTY_ID_FAILURE:
			return false;
		default:
			return state;
	}
};

export interface IPropertyEditPhotosState {
	uploading: ReturnType<typeof uploading>;
	errors: ReturnType<typeof errors>;
	successes: ReturnType<typeof successes>;
	deleting: ReturnType<typeof deleting>;
	loading: ReturnType<typeof loading>;
}

export default combineReducers<IPropertyEditPhotosState>({
	uploading,
	errors,
	successes,
	deleting,
	loading
});
